export const enum TWordCardSide {
  front = 'front',
  back = 'back',
}
